import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/images/cross.png'
import _imports_1 from '../assets/images/tick-shadow.png'


const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = {
  key: 0,
  class: "info"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "tick"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "shadow"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Oops!We can't find the page you're looking for.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Scan the QR code on the table to start making a payment.", -1)
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_powered_by_footer = _resolveComponent("powered-by-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_7))
      : _createCommentVNode("", true),
    _createVNode(_component_powered_by_footer)
  ]))
}